import React from "react";
import ReusableButton from "../Reusable/PrimaryButton/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { Grid, Typography } from '@mui/material';
import Showcaseoption from "./ShowcaseOptions";
import ModelCard from "../ModalCard/ModalCard";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';


const ShowcaseModels = ({
  models,
}: { models: any[] }) => {
  const navigate = useNavigate();
  const [filterType, setFilterType] = React.useState<string | null>(null);


  const handleFilterToggle = (type: string) => {
    setFilterType(prev => (prev === type ? null : type));
  };

  const filteredModels = filterType
    ? models.filter(model => model.type === filterType)
    : models;

const handleOnAdd = () => {
  navigate("/persona/add-model", { state: { modelName: "Person" } });
}



  return (
    <>
      {models && models.length > 0 ? (
        <div style={{ padding: "0px 30px", height: "90vh", overflowY: "auto" }}>
          <Grid container spacing={2} className="showcaseHeader">
            <Grid item xs={12} md={4} style={{ paddingTop: "0px", textAlign: "left" }}>
              <Typography variant="h5" className="showcaseTitle">Train images to stunning visuals</Typography>
              {/* <Typography variant="body1" className="showcaseDescription">Add more models for training</Typography> */}
            </Grid>
            <Grid item xs={12} md={6} className="showcaseFilter">
              <Typography className="search-text">Persona Type:</Typography>
              <Grid
              item
                alignItems="center"
                sx={{ display: "flex", gap: '4px', cursor: 'pointer' }}
                onClick={() => handleFilterToggle("Person")}
              >
                {filterType === 'Person' ? <PersonOutlineOutlinedIcon /> : <PersonOutlineOutlinedIcon sx={{ color: "#9D9FB2 !important" }}  />}
                <Typography className={filterType === 'Person' ? 'type-color' : "type-text"}>
                  Human Persona
                </Typography>
              </Grid>
              <Grid  item xs={6} md={2} sx={{ display: "flex", gap: '8px', cursor: 'pointer', alignItems: 'center' }}
                onClick={() => handleFilterToggle("AiInfluencer")}>
                <img src={filterType === 'AiInfluencer' ? '/assets/AIinflucncer.svg' : '/assets/AIInfluencerGray.svg'} alt="product" width="24px"
                  height="24px" />
                <Typography className={filterType === 'AiInfluencer' ? 'type-color' : "type-text"}>AI Persona</Typography>
              </Grid>
            </Grid>

            <Grid item xs={6} md={2} sx={{ display: "flex", justifyContent: { xs: "flex-start", md: "flex-end" } }}>
              <ReusableButton onClick={handleOnAdd}>+ Add Persona</ReusableButton>
            </Grid>
          </Grid>
          <div style={{ marginTop: "11px" }}>
            <div className="featured-showcase gradient-background">
              <Grid container spacing={2} direction="column">
                {/* Top Text Section */}
                <Grid style={{ paddingTop: "5px" }} item>
                  <Typography variant="body1" style={{ color: "#fff", fontSize: '16px', fontWeight: 400, fontFamily: 'var(--font-family-primary)' }}>Featured</Typography>
                  {/* <Typography style={{  color: "#fff", fontSize: '16px', fontWeight: 400, fontFamily: 'var(--font-family-primary)', marginBottom: "10px" }}>
                    Check out some of our most popular models
                  </Typography> */}
                </Grid>

                {/* Models Section */}
                {models.length > 0 && (
                  <Grid container spacing={2}>
                    {filteredModels.filter(model => model.type !== "Product").map((model, index) => (
                      <Grid item key={index} xs={12} sm={6} md={3}>
                        <ModelCard model={model} />
                      </Grid>
                    ))}
                  </Grid>
                )}
              </Grid>
            </div>
          </div>
        </div>
      ) : (
        <Showcaseoption />
      )}
    </>
  );
};

export default ShowcaseModels;